import { Abstrap } from '../../..';

const { propTypes } = Abstrap;

const defaultProps = {
    ...Abstrap.defaultProps,
    componentClass: 'input',
    type: 'text',
};

class FormInput extends Abstrap {

    getClassNameSchema() {
        const {
            className,
        } = this.props;
        return [
            'c-form__input',
            className,
        ];
    }

    renderChildren() {
        return undefined;
    }

}

FormInput.propTypes = propTypes;

FormInput.defaultProps = defaultProps;

export default FormInput;
